var _path, _rect, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuccessfulPackage = function SvgSuccessfulPackage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 131,
    viewBox: "0 0 203 131",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.25 8.44708H14.6776C12.5768 8.44708 10.8737 10.1502 10.8737 12.2511V69.2236V126.196C10.8737 128.297 12.5768 130 14.6776 130H198.25C200.351 130 202.054 128.297 202.054 126.196V12.2511C202.054 10.1502 200.351 8.44708 198.25 8.44708Z",
    fill: "#6FCF97",
    stroke: "#27AE60",
    strokeWidth: 1.45388
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8376,
    y: 30.6824,
    width: 185.253,
    height: 23.7176,
    rx: 1.45388,
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1949 92.9412H22.7672C21.9281 92.9412 21.2478 93.6215 21.2478 94.4606C21.2478 95.2998 21.9281 95.98 22.7672 95.98H80.1949C81.034 95.98 81.7143 95.2998 81.7143 94.4606C81.7143 93.6215 81.034 92.9412 80.1949 92.9412Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0783 102.058H22.7672C21.9281 102.058 21.2478 102.738 21.2478 103.577C21.2478 104.416 21.9281 105.097 22.7672 105.097H65.0783C65.9174 105.097 66.5977 104.416 66.5977 103.577C66.5977 102.738 65.9174 102.058 65.0783 102.058Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1482 111.174H22.7672C21.9281 111.174 21.2478 111.854 21.2478 112.694C21.2478 113.533 21.9281 114.213 22.7672 114.213H74.1482C74.9874 114.213 75.6676 113.533 75.6676 112.694C75.6676 111.854 74.9874 111.174 74.1482 111.174Z",
    fill: "#27AE60"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.594,
    cy: 103.318,
    rx: 14.8202,
    ry: 14.8235,
    fill: "#27AE60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.824 119.384C188.696 119.384 195.887 112.191 195.887 103.318C195.887 94.4445 188.696 87.251 179.824 87.251C170.952 87.251 163.761 94.4445 163.761 103.318C163.761 112.191 170.952 119.384 179.824 119.384Z",
    fill: "#27AE60",
    stroke: "#6FCF97",
    strokeWidth: 2.48626
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3989 55.9688C44.0374 55.9688 55.9034 44.0995 55.9034 29.4588C55.9034 14.8182 44.0374 2.94883 29.3989 2.94883C14.7604 2.94883 2.89439 14.8182 2.89439 29.4588C2.89439 44.0995 14.7604 55.9688 29.3989 55.9688Z",
    fill: "white",
    stroke: "#27AE60",
    strokeWidth: 4.10233
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.569 23.3444L26.3423 35.5738L20.229 29.4591",
    stroke: "#27AE60",
    strokeWidth: 4.10233,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessfulPackage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/successful-package.7b44308a.svg";
export { ForwardRef as ReactComponent };